module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens31-5aa3c7f58b67d4c63d9eb90afc65eb94.jpg";